import { combineReducers } from 'redux';

import {
  getOrganizationRequest,
  getOrganizationFail,
  getOrganizationSuccess,
  saveOrganizationRequest,
  saveOrganizationFail,
  saveOrganizationSuccess,
  createOrganizationRequest,
  createOrganizationSuccess,
  createOrganizationFail,
  resetCurrentOrganization,
  initOrganizationSuccess,
  initOrganizationFail,
} from '../actions';
import { OrganizationAction, StateOrganization } from '../types';
import { Reducer } from '../../../types';

type ReducerOf<T extends keyof StateOrganization> = Reducer<StateOrganization, OrganizationAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case getOrganizationRequest.type:
    case resetCurrentOrganization.type:
      return null;

    case getOrganizationSuccess.type:
    case createOrganizationSuccess.type:
    case saveOrganizationSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getOrganizationRequest.type:
    case createOrganizationRequest.type:
    case saveOrganizationRequest.type:
      return true;

    case getOrganizationSuccess.type:
    case getOrganizationFail.type:
    case createOrganizationSuccess.type:
    case createOrganizationFail.type:
    case saveOrganizationSuccess.type:
    case saveOrganizationFail.type:
      return false;

    default:
      return state;
  }
};

const error: ReducerOf<'error'> = (state = false, action) => {
  switch (action.type) {
    case initOrganizationFail.type:
    case getOrganizationFail.type:
      return true;

    case initOrganizationSuccess.type:
    case getOrganizationSuccess.type:
    case resetCurrentOrganization.type:
      return false;

    default:
      return state;
  }
};

export default combineReducers<StateOrganization>({
  data,
  loading,
  error,
});
